export default function (state, val) {
    state.page = 1;
    state.loading = false;
    val.Items.forEach(i => {
    });
    state.items = val.Items;
}